import {
  Show,
  SimpleShowLayout,
  TextField,
  DateField,
  BooleanField,
} from "react-admin";
 export const GroupShow = (props) => (
  <Show title="Group Details" {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="description" />
      <TextField source="is_active" />
      <TextField source="created_at" />
      <TextField source="created_by" />
    </SimpleShowLayout>
  </Show>
);
